/*
 * Funnel events for the mosaic creator.
 *
 *   window.mosafyTrack('upload_done', { tiles: 42 })
 *
 * Each step is sent, as `mosafy_<step>`, to:
 *  - dataLayer (GTM / Elevar / server-side GTM): { event, mosafy: {...} }
 *  - Microsoft Clarity: custom event + tags, to filter session recordings
 *  - Shopify customer events (Shopify.analytics.publish), for custom pixels
 *  - window 'mosafy:creator' DOM event
 * Consent handling is left to each destination as configured; this file
 * only publishes events.
 *
 * Steps: creator_view, main_selected, tiles_added, upload_start, upload_done,
 * tiles_resent, generated, error, preview_view, regenerated, regenerate_failed,
 * preview_accepted, style_selected, size_selected, add_to_cart,
 * add_to_cart_failed.
 */
(function (root) {
  const IN_APP_BROWSERS = [
    [/Instagram/i, 'instagram'],
    [/FBAN|FBAV|FB_IAB|FBIOS/i, 'facebook'],
    [/Pinterest/i, 'pinterest'],
    [/TikTok|musical_ly|BytedanceWebview/i, 'tiktok'],
    [/Snapchat/i, 'snapchat'],
    [/LinkedInApp/i, 'linkedin'],
  ];
  const sentOnce = new Set();

  function inAppBrowser() {
    const ua = root.navigator?.userAgent || '';
    for (const [pattern, name] of IN_APP_BROWSERS) {
      if (pattern.test(ua)) return name;
    }
    return 'none';
  }

  function context() {
    return {
      country: root.Shopify?.country || null,
      locale: root.mosafyMarket?.locale || root.document?.documentElement.lang || null,
      in_app: inAppBrowser(),
      device: root.matchMedia?.('(max-width: 767px)').matches ? 'mobile' : 'desktop',
      page: root.location?.pathname || null,
    };
  }

  function track(step, detail = {}, options = {}) {
    if (options.once) {
      if (sentOnce.has(step)) return;
      sentOnce.add(step);
    }
    const name = `mosafy_${step}`;
    const payload = { ...context(), ...detail };

    try {
      (root.dataLayer = root.dataLayer || []).push({ event: name, mosafy: payload });
    } catch (_) {}
    try {
      if (typeof root.clarity === 'function') {
        root.clarity('event', name);
        root.clarity('set', 'mosafy_in_app', payload.in_app);
        root.clarity('set', 'mosafy_last_step', step);
        if (detail.code) root.clarity('set', 'mosafy_error', String(detail.code));
      }
    } catch (_) {}
    try {
      root.Shopify?.analytics?.publish?.(name, payload);
    } catch (_) {}
    try {
      root.dispatchEvent(new CustomEvent('mosafy:creator', { detail: { step, ...payload } }));
    } catch (_) {}
  }

  root.mosafyTrack = track;
})(window);
